import { match } from 'ts-pattern'
import type { AggregatedInvoice, DueDatePolicy } from 'Invoices/types'

export const getOptimisticDueDate = (
  policy: DueDatePolicy
): Pick<AggregatedInvoice, 'dueDate'> =>
  match(policy)
    .with({ type: 'MANUAL' }, ({ date }) => ({ dueDate: date }))
    .with({ type: 'PAYMENT_TERMS' }, () => ({ dueDate: undefined }))
    .exhaustive()
